import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaChartBar, FaMailBulk, FaPaperPlane, FaUser } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';
import { Form } from '@unform/web';
import Input from 'src/components/Forms/Input';


interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule(): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();

  const ChangeUser = async () => {
    addLoading({ title: 'Carregando', key: 'loading' });
    const content = await api.get('invitation-confirmation', { params: { limitItems: 100000 } });


    const items: Record<string, any>[] = [];

    let total = content?.data?.rows?.length;
    let confirmed = content?.data?.rows?.filter(i => i?.confirmated === 'Sim')?.length;
    let status = content?.data?.rows?.filter(i => i?.status === 'Sim')?.length;
    content?.data?.rows?.map(i => {
      const vip = i?.vip_category || 'CONGRESSISTA';
      const index = items?.findIndex(a => a?.vip_category === vip);



      if (index < 0) {
        const item = {
          vip_category: vip,
          count: 1,
          confirmated: i?.confirmated === 'Sim' ? 1 : 0,
          status: i?.status === 'Sim' ? 1 : 0
        }

        items.push(item);
      }
      else {
        items[index].count += 1;
        if (i?.confirmated === 'Sim') {
          items[index].confirmated += 1;
        }
        if (i?.status === 'Sim') {
          items[index].status += 1;
        }


      }




    })
    removeLoading('loading')


    addModal({
      title: '', theme: 'whiteModalMedium', content: <>


        <table className='table'>
          <tbody>
            <tr><td>Categoria</td><td>QTD</td><td>Confirmados</td><td>Participaram</td></tr>
            {items?.map(i => <tr><td>{i?.vip_category}</td><td>{i?.count}</td><td>{i?.confirmated}</td><td>{i?.status}</td></tr>)}

            <tr><td> Total</td><td>{total}</td><td>{confirmed}</td><td>{status}</td></tr>
          </tbody>
        </table>

      </>
    })

  }



  const moduleUpdate = (): JSX.Element => (
    <button className='searchButton' title='Alterar participante' onClick={() => { ChangeUser() }}><FaChartBar /></button>
  );

  return moduleUpdate();
}
